import { render, staticRenderFns } from "./Index2.vue?vue&type=template&id=481a71b6&scoped=true"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"
import style0 from "./Index2.vue?vue&type=style&index=0&id=481a71b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a71b6",
  null
  
)

export default component.exports